import React, { useState, useEffect } from "react"; // eslint-disable-line no-unused-vars
import { Link, LinearProgress, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useAuth0 } from "@auth0/auth0-react";
import { checkManagerRole } from "../../../shared/utilities/actions";

export interface ClaimButtonProps {}

export const ClaimButton = ({}: ClaimButtonProps): React.JSX.Element | null => {
  const [busy, setBusy] = useState<boolean>(true);
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"));
  const { isLoading, getAccessTokenSilently, user, isAuthenticated } =
    useAuth0();

  const [ein, setEin] = useState<string>("");
  const [isManager, setIsManager] = useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setBusy(true);
      let params = new URLSearchParams(document.location.search);
      let queryParameterEin = params.get("charityId");
      if (queryParameterEin) {
        setEin(queryParameterEin);
      }
      setBusy(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setBusy(true);
      let isManagerRequest = await checkManagerRole(
        ein,
        getAccessTokenSilently
      );
      setIsManager(isManagerRequest);
      setBusy(false);
    };
    if (isAuthenticated && ein) fetchData();
  }, [ein, isLoading, isAuthenticated]);

  if (isManager) {
    return (
      <Link href={`/charity-dashboard/?ein=${ein}`}>Manage this Charity</Link>
    );
  } else {
    //return <Link href={`/claim-charity/?ein=${ein}`}>Claim this Charity</Link>;
    return null;
  }
};
